/* eslint-disable @typescript-eslint/no-explicit-any */

import { SWRConfiguration } from 'swr';

const REFRESH_INTERVAL = 5 * 1000;

export const swrConfig: SWRConfiguration = {
  refreshInterval: REFRESH_INTERVAL,
};
